export const css = /* css */ `
:host,
:host *,
*::before,
*::after {
  box-sizing: border-box;
}
a {
  color: inherit;
}
:not(.focus-visible),
:host(:not(.focus-visible)) {
  outline: none;
}
[hidden] {
  display: none !important;
}
:host {
  display: block;
  --slicesui-image-grid-color: rgba(255,255,255,0.7);
  --slicesui-image-scale: 1;
}
:host #placeholder[src] {
  opacity: 1;
}
:host #placeholder[src^="http"] {
  display: none;
}
:host figure {
  padding: 0;
  margin: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: var(--slicesui-image-background-color, transparent);
}
:host img {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  transition: 1s opacity;
  width: 100%;
  height: 100%;
  object-fit: var(--slicesui-image-object-fit, contain);
  object-position: var(--slicesui-image-object-position, 50% 50%);
  border: 0;
  border-style: none;
  opacity: 0;
  box-sizing: border-box;
  padding: 0;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  pointer-events: none;
}
:host([editable]) img {
  pointer-events: all;
}
:host([loaded]) #placeholder[src] {
  transition-delay: 0.25s;
  opacity: 0;
}
:host([loaded]) #full[srcset] {
  opacity: 1;
  animation-name: var(--slicesui-image-animation-name);
  animation-play-state: var(--slicesui-image-animation-play-state, paused);
  animation-duration: var(--slicesui-image-animation-duration, 20s);
  animation-direction: var(--slicesui-image-animation-direction, normal);
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}
[hidden] {
  display: none !important;
}
`;